import { IndicatorsRenderer } from '../../../core/components/annotations/components/indicators/IndicatorsRenderer.js';
import { getUniqueIndicatorsByPriority } from '../../../core/components/annotations/components/indicators/utils/get-unique-indicators-by-priority.js';
import { plotLayout } from '../../../core/components/chart-grid/ChartGrid.sty.js';
import { useTimeseriesChartAnnotationsData } from '../../hooks/useTimeseriesChartAnnotationsData.js';
import { useXScales } from '../../hooks/useXScale.js';

export const TimeseriesAnnotationsIndicators = () => {
  const { indicators } = useTimeseriesChartAnnotationsData();
  const { currentScale: xScale } = useXScales();
  const [domainStart, domainEnd] = xScale.domain();

  const uniqueIndicators = getUniqueIndicatorsByPriority(indicators, [
    domainStart.valueOf(),
    domainEnd.valueOf(),
  ]);

  return (
    <svg className={plotLayout}>
      {uniqueIndicators.map((track, index) =>
        track.map(([key, indicator]) => (
          <IndicatorsRenderer
            key={key}
            {...indicator}
            trackIndex={index}
            scale={xScale}
          />
        )),
      )}
    </svg>
  );
};
